export default function iso8601ToTimeCode(iso8601: string): number {
    if (null === iso8601.match(/^\d{4}-\d{2}-\d{2}$/)) {
        throw new Error("Value is not an ISO 8601 date: " + iso8601);
    }
    return Number(iso8601.replace(/-/g, ""));
}
